import * as o from "react";
import e from "../lib/IconBase.es.js";
import r from "../defs/WhatsappLogo.es.js";
const a = o.forwardRef((t, p) => /* @__PURE__ */ o.createElement(e, { ref: p, ...t, weights: r }));
a.displayName = "WhatsappLogoIcon";
const c = a;
export {
  c as WhatsappLogo,
  a as WhatsappLogoIcon
};
